module.exports = __webpack_public_path__ + "img/chara_line_2_white.1831bac3.png";